import React from "react";
import Button from "@mui/material/Button";

interface CancelButtonProps {
  onClose: () => void;
  sx?: object;
}

/**
 * CancelButton component
 * @param {CancelButtonProps} props - The props for the CancelButton component
 * @returns {Element} The CancelButton component
 */
function CancelButton({ onClose, sx = {} }: CancelButtonProps): JSX.Element {
  return (
    <Button
      variant="outlined"
      onClick={onClose}
      sx={{
        backgroundColor: "var(--white)",
        fontSize: {xs: 18, md: 25},
        height: {xs: 48, md: 62},
        width: {xs: 95, md: 115},
        minWidth: 'fit-content',
        borderRadius: "10px",
        fontWeight: "fontWeightMedium",
        border: "3px solid var(--gray-250)",
        color: "var(--black)",
        ":hover": {
          border: "3px solid var(--info)",
          color: "var(--info)",
        },
        ...sx,
      }}
    >
      閉じる
    </Button>
  );
}

export default CancelButton;
